<template>
  <v-btn
    tile
    large
    color="primary"
    class="non-text-transformation link"
    :disabled="disabled"
    @click="handleClick"
  >
    {{ $t('STEPPER_BUTTON_MANUAL_SIGN') }}
  </v-btn>
</template>

<script>
export default {
  name: 'ManualSignButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>
